
import browser from './browser';
import $ from "jquery";

// $(".english.home").click(function() {
//     location.replace("./index.html");
// });
// $(".chinese.home").click(function() {
//     location.replace("./index-zh.html");
// });
//
// $(".english.about-us").click(function() {
//     location.replace("./about_en.html");
// });
// $(".chinese.about-us").click(function() {
//     location.replace("./about_ch.html");
// });
//
// $(".english.ecosystem").click(function() {
//     location.replace("./eco_en.html");
// });
// $(".chinese.ecosystem").click(function() {
//     location.replace("./eco_ch.html");
// });
//
// $(".english.in-progress").click(function() {
//     location.replace("./inprogress_en.html");
// });
// $(".chinese.in-progress").click(function() {
//     location.replace("./inprogress_ch.html");
// });

// 语言切换
// var lang = window.localStorage.getItem('lang') || 'lang-en';
// if (lang === 'lang-zh') {
//     $('body').addClass('lang-zh');
//     $('a[data-lang="zh"]').addClass('active');
//
// } else {
//     $('body').addClass('lang-en');
//     $('a[data-lang="en"]').addClass('active');
// }

// 下载
(function () {
    var IOS_DOWNLOAD = 'https://apps.apple.com/us/app/tweebaa/id1467778439';
    var ANDROID_DOWNLOAD = 'https://tweebaafiles.oss-cn-beijing.aliyuncs.com/archive/app/tweebaa.apk';
    // var ANDROID_DOWNLOAD = 'https://play.google.com/store/apps/details?id=cn.charity.tweebaa';

    var IOS_DOWNLOAD_CHINA = IOS_DOWNLOAD + '?l=zh&ls=1';
    var ANDROID_DOWNLOAD_CHINA = 'https://tweebaafiles.oss-cn-beijing.aliyuncs.com/archive/app/tweebaa.apk';

    var $downloadIos = $('.download-link-ios');
    var $downloadAndroids = $('.download-link-android');

    function setZh() {
        $downloadIos.attr('href', IOS_DOWNLOAD_CHINA);
        $downloadAndroids.attr('href', ANDROID_DOWNLOAD_CHINA);
    }

    function setEn() {
        $downloadIos.attr('href', IOS_DOWNLOAD);
        $downloadAndroids.attr('href', ANDROID_DOWNLOAD);
    }

    if (lang === 'lang-zh') {
        setZh();
    } else {
        setEn();
    }

    // const COUNTRY_KEY = 'COUNTRY_CODE';
    // var currentCountryCode = window.localStorage.getItem(COUNTRY_KEY);
    // if (currentCountryCode === null) {
    //     $.ajax({
    //         type: "GET",
    //         url: "https://api.ipdata.co/?api-key=78e1295abccb1616027b85a6bcb612d286aef4cdb397a2c091fd861a",
    //         data: {},
    //         dataType: "json",
    //         success: function(response){
    //             var countryCode = response.country_code.toUpperCase();
    //             window.localStorage.setItem(COUNTRY_KEY, countryCode);
    //             if (countryCode === 'CN') {
    //                 setZh();
    //             } else {
    //                 setEn();
    //             }
    //         }
    //     });
    // } else {
    //     if (currentCountryCode === 'CN') {
    //         setZh();
    //     } else {
    //         setEn();
    //     }
    // }

})();



$('.lang-select').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.lang-select').removeClass('active');
    var $this = $(this);
    $this.addClass('active');
    var lang = $this.attr('data-lang');
    if (lang === 'lang-zh') {
        $('body').removeClass('lang-en').addClass('lang-zh');
        window.localStorage.setItem('lang', 'lang-zh');
    } else {
        $('body').removeClass('lang-zh').addClass('lang-en');
        window.localStorage.setItem('lang', 'lang-en');
    }

    $(document).trigger("switch-lang");

    if (browser.isMobile() === true) {
        let $navigation = $(".nav-mobile .navigation");
        $navigation.css({
            right: '-100%'
        });
    }
});

// 电报
if (browser.isMobile() === true) {
    var $ul = $('.telegram-list');
    $('#dianbao').click(function () {
        if ($ul.is(':hidden') === true) {
            $ul.show();
        } else {
            $ul.hide();
        }
    });
}

